<template>
    <main class="center full">
        <loader :loading="loading"></loader>
        <section id="campaign" class="flexContainer fd-c full">
            <h1 class="ff-medium txtCenter createCampaign">{{ $t("campaign.create") }}</h1>
            <section id="campaignWrapper">
                <div class="center flexContainer jc-c">
                    <div class="form_campaing">
                        <div class="">
                            <br />
                            <div class="form-group row">
                                <label class="col-4 col-form-label label">{{ $t("brand.name") }}</label>
                                <div class="col-8">
                                    <input
                                        type="text"
                                        class="campaign ff-medium size2of3"
                                        :placeholder="$t('campaign.campaignName')"
                                        v-model="name"
                                        :maxlength="MAX_LENGTH_NAME"
                                        minlength="5"
                                    />
                                    <input
                                        type="text"
                                        class="campaign ff-medium size1of3 shortName"
                                        style="margin-left: 10px;"
                                        maxlength="5"
                                        :placeholder="$t('campaign.shortName')"
                                        v-model="shortName"
                                    />
                                </div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label class="col-4 col-form-label label">{{ $t("campaign.startCampaign") }}</label>
                                <div class="col-8">
                                    <select
                                        id="soflow-color"
                                        class="campaign uppercase"
                                        v-model="lastCampaign"
                                        :disabled="radioButton === 'campaignDate'"
                                        :class="{ disabled: radioButton === 'campaignDate' }"
                                    >
                                        <option selected class="uppercase" :value="null">{{ $trad.campaignCreate.previousCampaign }}</option>
                                        <option v-for="campaign in campaigns" :key="campaign.id" :value="campaign" class="uppercase">
                                            {{ campaign.name }}
                                        </option>
                                    </select>
                                    <input
                                        type="date"
                                        class="campaign startDate"
                                        style="margin-left: 10px"
                                        placeholder="YYYY-MM-DD"
                                        v-model="startDate"
                                        :disabled="radioButton === 'lastCampaign'"
                                        :class="{ disabled: radioButton === 'lastCampaign' }"
                                    />
                                </div>
                            </div>
                            <br />
                            <div class="form-group row">
                                <label class="col-4 col-form-label label">{{ $t("campaign.endCampaign") }}</label>
                                <div class="col-8"><input type="date" placeholder="YYYY-MM-DD" class="campaign" v-model="endDate" /></div>
                            </div>
                            <br />
                            <footer class="txtCenter">
                                <RoundedButton :disabled="!canSave" @click="createCampaign();"> {{ $t("campaign.createBtn") }} </RoundedButton>
                            </footer>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </main>
</template>

<script>
import httpService from "@/components/service";
import loader from "@/components/loader/loader";
import RoundedButton from "@/catalog/components/rounded-button";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import { isValidNameLength } from "@/utils/string";

export default {
    mixins: [TryLoadMixin],
    data: () => ({
        name: undefined,
        shortName: undefined,
        startDate: null,
        endDate: null,
        lastCampaign: null,
        stands: [],
        radioButton: false,
        campaigns: [],
        loading: false
    }),
    components: {
        loader,
        RoundedButton
    },
    methods: {
        async createCampaign() {
            this.loading = true;
            if (!this.campaignNameIsCorrect) {
                return false;
            }
            try {
                let campaign = {
                    name: this.name.trim(),
                    shortName: this.shortName,
                    launchDate: this.startDate,
                    endDate: this.endDate || null,
                    isClosed: false,
                    lastCampaign: {
                        id: (this.lastCampaign && this.lastCampaign.id) || null
                    }
                };
                const res = await httpService.post("/admin/campaigns", JSON.stringify(campaign));
                if (res.code) throw res.message;
                try {
                    await this.$swal({
                        text: this.$t("campaignCreate.successCreateTxt"),
                        type: "success",
                        confirmButtonText: this.$t("campaignCreate.seeNewConfirmBtnText"),
                        confirmButtonColor: "#41b4e8",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showCancelButton: true,
                        cancelButtonText: this.$t("campaignCreate.seeNewCancelBtnText")
                    });
                    location.reload();
                } catch (e) {
                    this.$router.push("/campaigns/campaign-list");
                }
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        },
        async getCampaigns() {
            try {
                const res = await httpService.get("/admin/campaigns/list?limit=100");
                this.campaigns = res.data;
            } catch (e) {
                this.dialogError(e);
            }
        }
    },
    computed: {
        campaignNameIsCorrect() {
            return isValidNameLength(this.name);
        },
        canSave() {
            return this.campaignNameIsCorrect && this.startDate;
        }
    },
    created() {
        this.getCampaigns();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";

.selectBrand,
.createCampaign {
    font-family: "Oswald", Sans-Serif;
    font-size: 35px;
}

h1 {
    padding-bottom: 20px;
    padding-top: 30px;
}

select {
    border: 1px solid #aaa;
    color: #555;
    font-size: 1.4rem;
    height: 30px;
    width: 100%;
}

input {
    font-size: 1.4rem;
    padding-left: 10px;
}

#campaign {
    margin-top: 10px;
    display: block;
    border-radius: 3px;
    @extend %primary-text;
}

#campaignWrapper {
    padding: 10px 30px 10px 30px;
}

.campaign {
    margin-bottom: 10px;
    border: none;
    background-color: transparent;
    border-bottom: 1px solid #343434;
    height: 30px;
    width: 100%;
    font-family: Roboto;
    font-size: 14px;
    .startDate {
        margin-top: 12px;
    }
}

.bloc {
    padding-top: 20px;
}

input {
    height: 30px;
    border: 1px solid;
}

input,
select {
    @extend %primary-text;
    @extend %primary-border-color;
}

div.form_campaing {
    width: 32%;
}
</style>



// WEBPACK FOOTER //
// Campaign.vue?be786ab0